import { Label as AriaLabel, LabelProps as AriaLabelProps } from "react-aria-components";

import Typography from "ds/components/Typography";
import { getColors } from "ds/components/Form/Field/utils";
import { FormFieldColor } from "ds/components/Form/Field/types";

import styles from "./styles.module.css";

type FormFieldAriaLabelProps = {
  label: string;
  color?: FormFieldColor;
} & AriaLabelProps;

const FormFieldAriaLabel = ({ color, label, ...labelProps }: FormFieldAriaLabelProps) => {
  const { primaryTextColor } = getColors(color);

  return (
    <AriaLabel className={styles.ariaLabel} {...labelProps}>
      <Typography className={styles.ariaLabelText} tag="span" color={primaryTextColor}>
        {label}
      </Typography>
    </AriaLabel>
  );
};

FormFieldAriaLabel.displayName = "DS.FormField.AriaLabel";

export default FormFieldAriaLabel;
